import { useMutation, useQueryClient } from "@tanstack/react-query";

import { FaxServices } from "../services/services";
import type { SendFaxRequest, FaxType } from "../types/types";

export const useSendFax = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data: SendFaxRequest) => FaxServices.sendFax(data),
    onSuccess: async () => {
      // Invalidate and refetch fax history + daily usage queries
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["fax-history"] }),
        queryClient.invalidateQueries({ queryKey: ["fax-daily-usage"] }),
      ]);
    },
    onError: async (error) => {
      // Error handling is already done in the service layer
      await queryClient.invalidateQueries({
        queryKey: ["fax-history"],
      });

    },
  });

  const sendFax = async (data: SendFaxRequest): Promise<FaxType> => {
    return mutation.mutateAsync(data);
  };

  return {
    sendFax,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
    reset: mutation.reset,
  };
};